import React, { memo } from 'react';
import { Typography, TextField } from '@mui/material';
import { FormFieldsProps } from '../types';

const FormFields = memo(({
	formData,
	onUpdate,
	categoryType,
	language,
	category,
	isSubcategory
}: FormFieldsProps) => (

	<>
		<Typography variant='body2' pt={0.5}>
			{isSubcategory ? 'Sub Category Name*' : [ 'category', 'categoryData' ].includes(categoryType) ? 'Category Name*' : 'Playlist Name*'}
		</Typography>
		<TextField
			value={formData?.title}
			onChange={(e) => onUpdate('title', e.target.value)}
			fullWidth
			placeholder='Enter Title'
			margin='dense'
			size='small'
			inputProps={{ maxLength: 50 }}
		/>
		<Typography textAlign={'end'} color={'#707070'} fontSize={'var(--pixel12)'}>
			{formData?.title?.length}/50
		</Typography>

		<Typography variant='body2' pt={0.5}>
			{language?.description}
		</Typography>
		<TextField
			value={formData?.description}
			onChange={(e) => onUpdate('description', e.target.value)}
			fullWidth
			multiline
			rows={3}
			placeholder={`${language?.enterDescript}...`}
			margin='dense'
			inputProps={{ maxLength: 250 }}
		/>
		<Typography textAlign={'end'} color={'#707070'} fontSize={'var(--pixel12)'}>
			{formData?.description?.length}/250
		</Typography>
	</>
));

FormFields.displayName = 'FormFields';

export default FormFields;